<template>
  <div v-loading="loading" style="width: 800px;margin: 60px auto 0 auto;">

    <div>
      <el-form :inline="true" :model="request" class="demo-form-inline" size="small">
        <el-form-item>
          <el-button type="danger" size="small" @click="dialogFormVisible = true">新增课程系列</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div>
      <el-table
        :data="table.data.filter(data => !search || data.seriesName.toLowerCase().includes(search.toLowerCase()))"
        style="width: 100%">
        <el-table-column label="课程系列名称" prop="seriesName">
        </el-table-column>
        <el-table-column label="操作">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search"
              size="small"
              placeholder="输入课程系列名称搜索"/>
          </template>
          <template #default="scope">
            <el-button
              size="small"
              type="primary"
              @click="editLearnTask(scope.row.seriesCode, scope.row.seriesName)">编辑课程系列
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog title="新增课程系列" :visible.sync="dialogFormVisible" width="30%">
      <el-form :inline="true" :model="series" class="demo-form-inline">
        <el-form-item>
          <el-input v-model="series.name" size="small" placeholder="请输入课程名称名称" style="width: 360px;"/>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="addLearnTask">确认新增</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
  import { doGetAllLearnTask } from '@/utils/server';

  export default {
    name: "list",
    data() {
      return {
        loading: false,
        dialogFormVisible: false,
        search: '',
        request: { likeUsername: '', current: 1, size: 10 },
        series: {
          code: '',
          name: ''
        },
        table: {
          total: 0,
          data: []
        }
      }
    },
    methods: {
      addLearnTask() {
        let seriesCode = this.getUid();
        let seriesName = this.series.name;
        this.series.name = '';
        this.$router.push({
          path: '/LearnAddEdit',
          query: { seriesCode: seriesCode, seriesName: seriesName }
        });
      },
      editLearnTask(seriesCode, seriesName) {
        this.$router.push({
          path: '/LearnAddEdit',
          query: { seriesCode: seriesCode, seriesName: seriesName }
        });
      },
      getAllLearnTask() {
        this.loading = true;
        doGetAllLearnTask({}).then(response => {
          this.table.data = response.data;
          this.loading = false;
        });
      },
      getUid() {
        return 'series_' + new Date().getTime();
      }
    },
    mounted() {
      this.getAllLearnTask();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/learntask/list.vue